import { Injectable } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';
import { ConfigService } from './json-config.service';
import { LoggerService } from './logger/logger.service';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { LOCAL_STORAGE_KEYS } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthLinksService {
  private _localAppOrigin = '';

  public get localAppOrigin(): string {
    const origin = window?.location?.origin;
    if(origin) {
      this._localAppOrigin = origin;
    }

    return this._localAppOrigin;
  }

  public get clientRedirectUri(): string {
    return this.localAppOrigin + '/oauth/bcas/callback';
  }

  public get consultRedirectUri(): string {
    return this.localAppOrigin + '/oauth/bcas/consult-callback';
  }


  public get bcasLoginUrlBase(): string {
    return `${this.configService.getConfig(EnvironmentKeys.oauthUrl)}/auth?client_id=${this.configService.getConfig(EnvironmentKeys.clientId)}&response_type=${this.configService.getConfig(EnvironmentKeys.responseType)}&state=${this.configService.getConfig(EnvironmentKeys.state)}&scope=openid`;
  }

  public get bcasClientLoginUrl(): string {
    return this.bcasLoginUrlBase + this.cookiePreferences + `&redirect_uri=${this.clientRedirectUri}`;
  }

  public get bcasConsultLoginUrl(): string {
    return `${this.configService.getConfig(EnvironmentKeys.collabOauthUrl)}/auth?client_id=${this.configService.getConfig(EnvironmentKeys.collabId)}&response_type=${this.configService.getConfig(EnvironmentKeys.responseType)}&state=${this.configService.getConfig(EnvironmentKeys.state)}&scope=openid` + this.cookiePreferences + `&redirect_uri=${this.configService.getConfig(EnvironmentKeys.bwmWorkplaceLink)}oauth/bcas/consult-callback`;
  }

  private get cookiePreferences(): string {
    let trackingCookiePreferences = 'track=';

    try {
      if(CookieConsent.getUserPreferences().acceptedCategories.includes(LOCAL_STORAGE_KEYS.COOKIES_ANALYTICS_CATEGORY)) {
        trackingCookiePreferences += '1';
      } else {
        trackingCookiePreferences += '0';
      }
    } catch (error) {
      console.error('Error when passing cookie preferences.');
      this.loggerService.error(error);
      trackingCookiePreferences += '0';
    }

    return '&' + trackingCookiePreferences;
  }

  public constructor(
    private configService: ConfigService,
    public loggerService: LoggerService,
  ) { }
}
